<template>
  <div class="main">
    <div class="logo"></div>
  <div class="content resetpwd">
    <div class="title font-size24 color-msg">安全验证</div>
    <div class="font-size14 color-msg cue" v-show="this.inputType === CONF.inputType.mobile">请使用手机<span>{{account}}</span>获取验证码</div>
    <div class="font-size14 color-msg cue" v-show="this.inputType === CONF.inputType.mobileOrEmail">请使用邮箱<span>{{account}}</span>获取验证码</div>
    <div class="ipt-box font-size14">
      <img-code :imgCodeErrData="imgCodeErrData" :options='imgCodeData' @imgCodeSuccess="imgCodeSuccess" ></img-code>
      <mobile-code :mobileCodeBtnState="mobileCodeBtnState" :inputType="CONF.inputType.mobileOrEmail" :imgCode="imgCode" :codeErrData="codeErrData"
                   @mobileCodeSuccess="mobileCodeSuccess" @mobileCodeSendFail="mobileCodeSendFail" ></mobile-code>
    </div>
    <div class="account-btn" @click="verificationCode" v-show=" submitBtnState==CONF.submitBtnState.enable">确&nbsp;定</div>
    <div class="account-btn disable" v-show=" submitBtnState==CONF.submitBtnState.disable">确&nbsp;定</div>
  </div>
  </div>
</template>
<script>
  import {mtvConfig as CONF, mtvServers as server} from '../services/services'
  import MobileCode from '../components/mobileCode'
  import ImgCode from '../components/imgCode'

  export default {
    components: {MobileCode, ImgCode},
    data () {
      return {
        CONF: CONF,
        account: '',
        inputType: CONF.inputType.mobile,
        imgCodeData: {},
        imgCodeErrData: {},
        verifyCode: '',
        mobileCodeBtnState: CONF.mobileCodeState.disable,
        imgCode: '',
        callback: '',
        codeErrData: {},
        submitBtnState: CONF.submitBtnState.disable
      }
    },
    created () {
      if (this.$route.params.inputType === undefined || this.$route.params.account === undefined) {
        this.$router.push(CONF.urlList.ResetGetAccount.path + window.location.search)
      }
      this.inputType = this.$route.params.inputType
      this.account = this.$route.params.account
      this.imgCodeData = {inputType: CONF.inputType.mobileOrEmail, imgSrc: CONF.APIList.resetpwdImgCode}
    },
    methods: {
// 填写图形验证码格式正确
      imgCodeSuccess (imgCode) {
        if (imgCode.length === 0) {
          this.mobileCodeBtnState = CONF.mobileCodeState.disable
          return
        }
        this.mobileCodeBtnState = CONF.mobileCodeState.enable
        this.imgCode = imgCode
      },
// 填写手机验证码
      mobileCodeSuccess (mobileCode) {
        this.verifyCode = mobileCode
        if (this.verifyCode.length === 0) {
          this.submitBtnState = CONF.submitBtnState.disable
        } else {
          this.submitBtnState = CONF.submitBtnState.enable
        }
      },
// 发送短信验证码错误
      mobileCodeSendFail (code) {
        this.imgCodeErrData = {errMsgShow: true, errMsg: CONF.errCode['code' + code].msg}
      },
// 验证码提交
      verificationCode () {
        if (!CONF.reg.mobileCode.test(this.verifyCode)) return
        let that = this
        let data = {verifyCode: this.verifyCode}
        this.submitBtnState = CONF.submitBtnState.disable
        server.appServices(this, CONF.APIList.resetpwdValidate, data).then(res => {
          if (res.status === CONF.errCode.success.code) {
            let nextRoute = CONF.urlList.ResetSetPwd
            nextRoute.query = {}
            if (this.$route.query.callback) {
              nextRoute.query.callback = this.$route.query.callback
            }
            if (this.$route.query.connectid) {
              nextRoute.query.connectid = this.$route.query.connectid
            }
            nextRoute.params = {verifyCode: that.verifyCode, account: that.account}
            this.$router.push(nextRoute)
          } else {
            this.submitBtnState = CONF.submitBtnState.enable
            if (res.status === CONF.errCode.code103.code) {
              that.codeErrData = {errMsgShow: true, errMsg: CONF.errCode['code' + res.status].msg}
            } else {
              that.imgCodeErrData = {errMsgShow: true, errMsg: CONF.errCode['code' + res.status].msg}
            }
          }
        })
      }
    }
  }
</script>
<style>
  .resetpwd .title{
    margin-bottom: 30px;
  }
</style>



// WEBPACK FOOTER //
// ResetGetCode.vue?19bfadf8